import { useEffect, useState } from "react";
import { notNullNorUndefined } from "shared/helpers/notNullNorUndefined";

type MeasureButtonState = {
  undoDisabled: boolean;
  confirmDisabled: boolean;
};

type UseMeasureButtons = () => MeasureButtonState;

/**
 * Manage the state of the measure buttons.
 *
 * Specifically for:
 *  - Undo
 *  - Confirm
 */
export const useMeasureButtons: UseMeasureButtons = () => {
  const [buttonState, setButtonState] = useState<MeasureButtonState>({
    undoDisabled: true,
    confirmDisabled: true,
  });

  // This listener is for when krpano is used to change measure-mode
  useEffect(() => {
    const setMeasureButtonStateHandler = (
      event: WindowEventMap["krpano__measure_item_change"]
    ) => {
      if (
        notNullNorUndefined(event.detail) &&
        notNullNorUndefined(event.detail.itemCount)
      ) {
        const itemCount = event.detail.itemCount;
        setButtonState({
          undoDisabled: itemCount === 0,
          confirmDisabled: itemCount <= 1,
        });
      } else {
        // TODO: KrpanoDispatchedEvent Error handling
      }
    };
    window.addEventListener(
      "krpano__measure_item_change",
      setMeasureButtonStateHandler
    );
    return () => {
      window.removeEventListener(
        "krpano__measure_item_change",
        setMeasureButtonStateHandler
      );
    };
  }, []);
  return buttonState;
};
